import React from 'react';

// Props = Label, Name, Validation, handleChange
const TextInput = (props) => {
	const validClass = (props.validation.isInvalid) ? 'app__form-input--error' : '';

	return (
		<div className="app__form-group">
			<label htmlFor={`emco_${props.inputName}`}>
				{props.label}
				<input className={`app__form-input ${validClass}`} type="text" id={`emco_${props.inputName}`} name={props.inputName} autoCapitalize="none" onChange={props.handleChange} />
			</label>
			<div className="app__form--error">{props.validation.message}</div>
		</div>
	)
}

export default TextInput;


// WEBPACK FOOTER //
// ./src/components/TextInput.js